<template lang="html">
  <article class="">
    <h3 style="text-align: center; margin-bottom: 24px;">Agentes</h3>
    <v-layout row wrap>
      <v-flex xs4 v-for="agent in agents" style="padding: 40px">
        <v-card>
          <v-card-title primary-title>
            <div>
                <span style="color: #90A4AE; text-transform: uppercase">Nombre:</span><br>
                {{agent.attributes.name}}
              </p>
              <p>
                <span style="color: #90A4AE; text-transform: uppercase">Apellido:</span><br>
                {{agent.attributes.last_name}}
              </p>
              <p>
                <span
                style="color: #90A4AE; text-transform: uppercase">Locación:</span><br>
                {{agent.attributes.location.attributes.name}}
              </p>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              color="blue"
              @click="$router.push({name: 'agent_edit', params: {id: agent.id}})">
              Editar
            </v-btn>
            <v-btn
              color="red lighten-1"
              @click="deleteagent(agent.id)">
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </article>
</template>

<script>
export default {
  data(){
    return{
      agents:[],
      locations:[],
      charged: false
    }
  },
  methods:{
    deleteagent(id){
      try {
        this.$http.delete('agents/'+id,
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          for (var i = 0; i < this.agents.length; i++) {
            if(this.agents[i].id == id){
              this.agents.splice(i, 1)
            }
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }
  },
  mounted(){
    try {
      const data={company:{id:this.getCompany().id}}
      try {
        this.$http.post('locations/company',{data:this.encrypt(data).toString()},{
            headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
            }
        })
        .then(function(response){
          this.locations= response.body.data
          console.info(this.locations)
          this.$http.get('agents',
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}})
          .then(function(response){
            this.agents = response.body.data
            var context=this
            for (var i=0;i<this.agents.length;i++){
              var id = this.locations.filter(function(val) {
                  return val.id == context.agents[i].attributes.location_id;
              });
              context.agents[i].attributes["location"]=id[0]
            }
            this.charged = true
          }, function(response){
            if(typeof response.body.errors[0].details != "object"){
              alert(response.body.errors[0].details);
            }else{
              let message = []
              for(var key in response.body.errors[0].details){
                message.push(response.body.errors[0].details[key])
              }
              alert(message);
            }
          })
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }

      } catch (e) {
        alert(e.message)
      }

  },
  created(){

  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/agents/Index.vue